import { FC, useState } from 'react';
import { Modal } from 'components';
import SectionStyled, { ContentStyled } from './styles';

const ApproveRKY: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);

  const okButton = { text: '承認', onClick: () => setVisible(false) };
  const cancelButton = { text: 'キャンセル', onClick: () => setVisible(false) };

  return (
    <SectionStyled>
      <button onClick={() => setVisible(true)}>Open modal Approve-RKY</button>
      <Modal
        title="RKY表を承認します。よろしいですか？"
        visible={visible}
        width={640}
        okButton={okButton}
        cancelButton={cancelButton}
      >
        <ContentStyled>この操作は元に戻せません</ContentStyled>
      </Modal>
    </SectionStyled>
  );
};

export default ApproveRKY;
